import { observable } from 'mobx';

export type TransitPriceResponseArgs = {
  price: number;
  seat_type: string;
  ticket_category: string;
  ticket_type: string | null;
  seat_count: string | number;
};

export type TransitPriceArgs = {
  price: number;
  seatType: string;
  ticketCategory: string;
  ticketType: string | null;
  seatCount: string | number;
};

export const convertTransitPriceResponseToArgs = (response: TransitPriceResponseArgs) => {
  const args: TransitPriceArgs = {
    price: response.price,
    seatType: response.seat_type,
    ticketCategory: response.ticket_category,
    ticketType: response.ticket_type,
    seatCount: response.seat_count
  };
  return args;
};

export default class TransitPrice {
  @observable price: number;
  @observable seatType: string;
  @observable ticketCategory: string;
  @observable ticketType: string | null;
  @observable seatCount: string | number;

  constructor(args: TransitPriceArgs) {
    this.price = args.price;
    this.seatType = args.seatType;
    this.ticketCategory = args.ticketCategory;
    this.ticketType = args.ticketType;
    this.seatCount = args.seatCount;
  }
}
